(function () {
  'use strict';
  var TIER_2_TOAST_KEY_PREFIX = 'ssl_tier2_toast_dismissed_';
  var TIER_2 = ['ar','bg','cs','da','de','el','es','fi','fr','hr','hu','id','it','ja','ko','lt','nb','nl','pl','pt-br','pt-pt','ro','ru','sk','sl','sv','th','tr','vi','zh-cn','zh-tw'];

  function open() {
    var d = document.querySelector('[data-ssl-locale-drawer]');
    if (!d) return;
    d.hidden = false;
    d.setAttribute('aria-hidden', 'false');
    var first = d.querySelector('input[type="radio"]:checked, input[type="radio"]');
    if (first) first.focus();
  }
  function close() {
    var d = document.querySelector('[data-ssl-locale-drawer]');
    if (!d) return;
    d.hidden = true;
    d.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ssl-locale-toggle]')) { open(); }
    if (e.target.closest('[data-ssl-locale-close]')) { close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Tier 2 toast — appears once per locale per visitor
  function maybeShowTier2Toast() {
    var current = (document.documentElement.dataset.sslLocale || '').toLowerCase();
    if (TIER_2.indexOf(current) === -1) return;
    var key = TIER_2_TOAST_KEY_PREFIX + current;
    if (localStorage.getItem(key)) return;
    var toast = document.querySelector('[data-ssl-tier2-toast]');
    if (!toast) return;
    toast.hidden = false;
    var dismiss = toast.querySelector('[data-ssl-tier2-dismiss]');
    if (!dismiss) return;
    dismiss.addEventListener('click', function () {
      toast.hidden = true;
      try { localStorage.setItem(key, '1'); } catch (e) { /* private mode */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeShowTier2Toast);
  } else {
    maybeShowTier2Toast();
  }
})();
